import React from "react";
import formConfig from "../../../config/form";

export default function InfoFooter({ apartment }) {
  const status =
    apartment.availability === "ennakkomarkkinoinnissa" ? "premarketing" : "onsale";
  const innerHtml = {
    __html: apartment.available
      ? formConfig.getFooter(status, "free")
      : formConfig.getFooter(status, "reserved"),
  };
  return <div className="font-serif" dangerouslySetInnerHTML={innerHtml}></div>;
}
